/**
 * CHARISMA COSMETICS — SKIN QUIZ v4 (CLEAN)
 * - data-q values match Liquid: skintype / concern / age / sensitivity / desired
 * - 7 steps total: 0=Intro 1=Lead 2-6=Questions 7=Analyzing
 * - Auto-popup fires once per browser session
 * - saveLead() runs only once per quiz session
 * - Google Apps Script URL comes from Theme Customizer (window.__SQ_GOOGLE_SCRIPT__)
 */

(function () {
  'use strict';

  const PRODUCTS = window.__SQ_PRODUCTS__ || {};

  const CONCERN_MAP = {
    melasma:      'melasma',
    fairness:     'fairness',
    acne:         'acne',
    darkspot:     'darkspot',
    antiaging:    'antiaging',
    dryness:      'dryness',
    pigmentation: 'pigmentation',
    dullness:     'dullness',
    haircare:     'haircare',
  };

  const SKIN_TYPE_LABELS = {
    oily:        'Oily Skin',
    dry:         'Dry Skin',
    combination: 'Combination Skin',
    normal:      'Normal Skin',
    sensitive:   'Sensitive Skin',
  };

  const DEFAULT_CONCERN = 'fairness';
  const CONCERNS_PER_PAGE = 4;
  const POPUP_SESSION_KEY = 'sq_shown_this_session';

  // Set this in Theme Customizer → Skin Quiz → Google Apps Script URL.
  // No hardcoded fallback: if it's empty, we simply skip the Sheets request.
  const GOOGLE_SCRIPT_URL = window.__SQ_GOOGLE_SCRIPT__ || '';

  const state = {
    currentStep:    0,
    answers:        {},
    lead:           { name: '', email: '', whatsapp: '' },
    chosenConcern:  null,
    chosenSkinType: null,
    whatsappNumber: '923001234567',
    concernPage:    0,
    leadSaved:      false,
  };

  let concernItems = [];

  /* =============================================
     INIT
  ============================================= */
  function init() {
    const section = document.getElementById('sq-section');
    if (section) {
      state.whatsappNumber = section.dataset.waNumber || state.whatsappNumber;
      const autoEnabled = section.dataset.autoPopupEnabled === 'true';
      const autoDelay   = parseInt(section.dataset.autoPopupDelay || '4000', 10);
      if (autoEnabled) scheduleAutoPopup(autoDelay);
    }
    buildConcernPagination();
  }

  /* =============================================
     AUTO POPUP — once per session
  ============================================= */
  function scheduleAutoPopup(delayMs) {
    if (sessionStorage.getItem(POPUP_SESSION_KEY)) return;
    setTimeout(() => {
      if (sessionStorage.getItem(POPUP_SESSION_KEY)) return;
      openQuiz();
      sessionStorage.setItem(POPUP_SESSION_KEY, '1');
    }, delayMs);
  }

  /* =============================================
     CONCERN PAGINATION
  ============================================= */
  function buildConcernPagination() {
    const container = document.getElementById('sq-concern-pages');
    const sourceList = document.getElementById('sq-concern-source');
    if (!container || !sourceList) return;

    concernItems = Array.from(sourceList.querySelectorAll('.sq-option'));
    const totalPages = Math.ceil(concernItems.length / CONCERNS_PER_PAGE);

    container.innerHTML = '';
    for (let p = 0; p < totalPages; p++) {
      const page = document.createElement('div');
      page.className = 'sq-concern-page' + (p === 0 ? ' active' : '');
      page.dataset.page = p;

      const slice = concernItems.slice(p * CONCERNS_PER_PAGE, (p + 1) * CONCERNS_PER_PAGE);
      slice.forEach(btn => {
        const clone = btn.cloneNode(true);
        clone.addEventListener('click', () => skinQuiz.selectOption(clone));
        page.appendChild(clone);
      });
      container.appendChild(page);
    }

    const dotsWrap = document.getElementById('sq-concern-dots');
    if (dotsWrap) {
      dotsWrap.innerHTML = '';
      for (let p = 0; p < totalPages; p++) {
        const dot = document.createElement('button');
        dot.className = 'sq-concern-dot' + (p === 0 ? ' active' : '');
        dot.dataset.page = p;
        dot.setAttribute('aria-label', 'Page ' + (p + 1));
        dot.addEventListener('click', () => showConcernPage(p));
        dotsWrap.appendChild(dot);
      }
    }
    updateConcernNav();
  }

  function showConcernPage(p) {
    const container = document.getElementById('sq-concern-pages');
    if (!container) return;
    const totalPages = Math.ceil(concernItems.length / CONCERNS_PER_PAGE);
    if (p < 0 || p >= totalPages) return;

    state.concernPage = p;
    container.querySelectorAll('.sq-concern-page').forEach((pg, i) => {
      pg.classList.toggle('active', i === p);
    });
    document.querySelectorAll('.sq-concern-dot').forEach((d, i) => {
      d.classList.toggle('active', i === p);
    });
    updateConcernNav();
  }

  function updateConcernNav() {
    const totalPages = Math.ceil(concernItems.length / CONCERNS_PER_PAGE);
    const prevBtn = document.getElementById('sq-concern-prev');
    const nextBtn = document.getElementById('sq-concern-next');
    if (prevBtn) prevBtn.disabled = state.concernPage === 0;
    if (nextBtn) nextBtn.disabled = state.concernPage >= totalPages - 1;
  }

  /* =============================================
     STEP NAVIGATION
  ============================================= */
  function goToStep(n) {
    document.querySelectorAll('.sq-step').forEach(s => s.classList.remove('active'));
    const next = document.querySelector(`.sq-step[data-step="${n}"]`);
    if (next) {
      next.classList.add('active');
      const scroll = document.querySelector('.sq-scroll');
      if (scroll) scroll.scrollTop = 0;
    }
    state.currentStep = n;
  }

  /* =============================================
     OVERLAY
  ============================================= */
  function openQuiz() {
    const overlay = document.getElementById('sq-overlay');
    if (overlay) {
      overlay.classList.add('active');
      document.body.style.overflow = 'hidden';
    }
  }

  function closeQuiz() {
    const overlay = document.getElementById('sq-overlay');
    if (!overlay) return;
    overlay.classList.remove('active');
    document.body.style.overflow = '';

    setTimeout(resetQuiz, 250);
  }

  function resetQuiz() {
    state.answers        = {};
    state.lead            = { name: '', email: '', whatsapp: '' };
    state.chosenConcern   = null;
    state.chosenSkinType  = null;
    state.concernPage     = 0;
    state.leadSaved       = false;

    ['sq-name', 'sq-email', 'sq-whatsapp'].forEach(id => {
      const el = document.getElementById(id);
      if (el) el.value = '';
    });

    document.querySelectorAll('#sq-concern-pages .sq-option').forEach(b => b.classList.remove('selected'));
    document.querySelectorAll('.sq-step .sq-option.selected').forEach(b => b.classList.remove('selected'));
    showConcernPage(0);

    const resultSection = document.getElementById('sq-result-popup');
    const analyzing = document.querySelector('.sq-step[data-step="7"]');
    if (resultSection) resultSection.style.display = 'none';
    if (analyzing) analyzing.style.display = '';

    ['sq-anim1', 'sq-anim2', 'sq-anim3', 'sq-anim4'].forEach(id => {
      const el = document.getElementById(id);
      if (el) el.classList.remove('show');
    });

    goToStep(0);
  }

  /* =============================================
     LEAD SAVING
  ============================================= */
  function saveLead() {
    if (state.leadSaved) return;
    state.leadSaved = true;

    try {
      const concern    = state.chosenConcern || DEFAULT_CONCERN;
      const skinType   = state.chosenSkinType || '';
      const productKey = CONCERN_MAP[concern] || DEFAULT_CONCERN;
      const product    = PRODUCTS[productKey] || {};
      const timestamp  = new Date().toLocaleString('en-PK', { timeZone: 'Asia/Karachi' });

      const data = {
        timestamp,
        name:         state.lead.name,
        email:        state.lead.email,
        whatsapp:     state.lead.whatsapp,
        skin_concern: concern,
        recommended:  product.name || '',
        skin_type:    SKIN_TYPE_LABELS[skinType] || skinType,
        age_group:    state.answers['age'] || '',
        sensitivity:  state.answers['sensitivity'] || '',
        desired_goal: state.answers['desired'] || '',
      };

      if (GOOGLE_SCRIPT_URL) {
        fetch(GOOGLE_SCRIPT_URL, {
          method:  'POST',
          mode:    'no-cors',
          headers: { 'Content-Type': 'application/json' },
          body:    JSON.stringify(data),
        }).catch(() => {});
      }

      try {
        const existing = JSON.parse(localStorage.getItem('cq_leads') || '[]');
        existing.push(data);
        localStorage.setItem('cq_leads', JSON.stringify(existing.slice(-100)));
      } catch (e) { /* localStorage unavailable — non-critical */ }

    } catch (e) {
      state.leadSaved = false;
    }
  }

  /* =============================================
     RESULT POPUP
  ============================================= */
  function showResultPopup() {
    const concern    = state.chosenConcern || DEFAULT_CONCERN;
    const skinType   = state.chosenSkinType || '';
    const productKey = CONCERN_MAP[concern] || DEFAULT_CONCERN;
    const product    = PRODUCTS[productKey] || {};

    setElText('sq-result-badge',  product.badge_text   || 'Recommended');
    setElText('sq-result-title',  product.result_title || 'Your Perfect Plan');
    setElText('sq-result-sub',    product.result_sub   || 'Based on your skin analysis');
    setElText('sq-product-name',  product.name         || 'Product Plan');
    setElText('sq-product-desc',  product.description  || '');
    setElText('sq-price-old',     product.old_price    || '');
    setElText('sq-price-new',     product.price        || '');
    setElText('sq-product-tag',   product.tag          || 'Best Seller');

    const strip = document.getElementById('sq-skin-type-strip');
    const skinValEl = document.getElementById('sq-skin-type-value');
    if (strip) {
      if (skinType) {
        strip.style.display = 'flex';
        if (skinValEl) skinValEl.textContent = SKIN_TYPE_LABELS[skinType] || skinType;
      } else {
        strip.style.display = 'none';
      }
    }

    const img = document.getElementById('sq-product-img');
    if (img) {
      if (product.image) { img.src = product.image; img.style.display = 'block'; }
      else img.style.display = 'none';
    }

    const promoWrap   = document.getElementById('sq-promo-wrap');
    const promoCodeEl = document.getElementById('sq-promo-code-text');
    const promoMsgEl  = document.getElementById('sq-promo-msg');
    const promoDiscEl = document.getElementById('sq-promo-discount-badge');
    const promoCode   = product.promo_code || window.__SQ_GLOBAL_PROMO__ || '';
    const promoMsg    = product.promo_msg  || window.__SQ_GLOBAL_PROMO_MSG__ || '';

    if (promoWrap) {
      if (promoCode) {
        promoWrap.style.display = 'block';
        if (promoCodeEl) promoCodeEl.textContent = promoCode;
        if (promoMsgEl) {
          promoMsgEl.textContent = (promoMsg && promoMsg !== promoCode) ? promoMsg : 'Apply at checkout to get discount';
          promoMsgEl.style.display = '';
        }
        if (promoDiscEl) {
          const match = promoMsg.match(/(\d+)%/);
          promoDiscEl.textContent = match ? match[1] + '% OFF' : 'DISCOUNT';
        }
      } else {
        promoWrap.style.display = 'none';
      }
    }

    setElText('sq-product-rating', '⭐⭐⭐⭐⭐  (1,000+ Reviews)');

    const buyBtn = document.getElementById('sq-btn-buy');
    if (buyBtn) buyBtn.href = product.url || '#';

    const waBtn = document.getElementById('sq-btn-whatsapp');
    if (waBtn) {
      const msg = encodeURIComponent(
        `Assalam o Alaikum! Main ${state.lead.name} hoon.\n\nMaine Charisma ka Skin Quiz kiya aur mujhe *${product.name || 'Skin Treatment Plan'}* recommend hua.\n\nKya aap mujhe is ke baray mein bata sakte hain? 🙏`
      );
      waBtn.href = `https://wa.me/${state.whatsappNumber}?text=${msg}`;
      waBtn.target = '_blank';
    }

    const analyzing = document.querySelector('.sq-step[data-step="7"]');
    const resultSection = document.getElementById('sq-result-popup');
    if (analyzing) analyzing.style.display = 'none';
    if (resultSection) resultSection.style.display = 'block';

    const scroll = document.querySelector('.sq-scroll');
    if (scroll) scroll.scrollTop = 0;
  }

  /* =============================================
     PUBLIC API
  ============================================= */
  const skinQuiz = {

    openModal()  { openQuiz(); },
    closeModal() { closeQuiz(); },
    start()      { goToStep(1); },

    submitLead() {
      const name  = document.getElementById('sq-name')?.value.trim()  || '';
      const email = document.getElementById('sq-email')?.value.trim() || '';
      const wa    = document.getElementById('sq-whatsapp')?.value.trim() || '';

      if (!name)                          { showError('Apna naam zaroor likhein 🙏');              return; }
      if (!email || !isValidEmail(email)) { showError('Sahi email address likhein');               return; }
      if (!wa || wa.length < 9)           { showError('Sahi WhatsApp number likhein (9-10 anka)'); return; }

      state.lead = { name, email, whatsapp: '+92' + wa };
      goToStep(2);
    },

    selectOption(el) {
      const q = el.dataset.q;
      const val = el.dataset.val;

      if (q === 'concern') {
        document.querySelectorAll('#sq-concern-pages .sq-option').forEach(b => b.classList.remove('selected'));
      } else {
        const container = el.closest('.sq-options, .sq-options-grid, .sq-options-row');
        if (container) container.querySelectorAll('.sq-option').forEach(b => b.classList.remove('selected'));
      }
      el.classList.add('selected');

      state.answers[q] = val;
      if (q === 'skintype') state.chosenSkinType = val;
      if (q === 'concern')  state.chosenConcern = val;

      setTimeout(() => {
        const next = state.currentStep + 1;
        if (next <= 6) {
          goToStep(next);
        } else {
          skinQuiz.runAnalysis();
        }
      }, 350);
    },

    concernPrev() { showConcernPage(state.concernPage - 1); },
    concernNext() { showConcernPage(state.concernPage + 1); },

    runAnalysis() {
      goToStep(7);
      const animIds = ['sq-anim1', 'sq-anim2', 'sq-anim3', 'sq-anim4'];
      animIds.forEach((id, i) => {
        setTimeout(() => {
          const el = document.getElementById(id);
          if (el) el.classList.add('show');
        }, 500 + i * 600);
      });
      const totalDelay = 500 + animIds.length * 600 + 300;
      setTimeout(() => {
        saveLead();
        showResultPopup();
      }, totalDelay);
    },

    copyPromo() {
      const codeEl = document.getElementById('sq-promo-code-text');
      const btn = document.getElementById('sq-copy-btn');
      if (!codeEl) return;
      const code = codeEl.textContent.trim();
      if (!code) return;

      const onSuccess = () => {
        if (btn) {
          btn.textContent = '✓ Copied!';
          btn.classList.add('copied');
          setTimeout(() => { btn.textContent = 'Copy'; btn.classList.remove('copied'); }, 2500);
        }
      };

      if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard.writeText(code).then(onSuccess).catch(() => fallbackCopy(code, onSuccess));
      } else {
        fallbackCopy(code, onSuccess);
      }
    },
  };

  /* =============================================
     HELPERS
  ============================================= */
  function fallbackCopy(text, cb) {
    const ta = document.createElement('textarea');
    ta.value = text;
    ta.style.cssText = 'position:fixed;top:-9999px;left:-9999px;opacity:0;';
    document.body.appendChild(ta);
    ta.focus();
    ta.select();
    try { document.execCommand('copy'); cb(); } catch (e) { /* clipboard unavailable */ }
    document.body.removeChild(ta);
  }

  function setElText(id, text) {
    const el = document.getElementById(id);
    if (el) el.textContent = text;
  }

  function isValidEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  }

  function showError(msg) {
    const existing = document.getElementById('sq-toast');
    if (existing) existing.remove();
    const toast = document.createElement('div');
    toast.id = 'sq-toast';
    toast.className = 'sq-toast';
    toast.textContent = msg;
    document.body.appendChild(toast);
    setTimeout(() => { if (toast.parentNode) toast.remove(); }, 3500);
  }

  document.addEventListener('click', function (e) {
    if (e.target && e.target.id === 'sq-overlay') closeQuiz();
  });

  window.skinQuiz = skinQuiz;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();